import { useEffect, useState } from "react";
import type { SoundfontEntry } from "@midi-fantom-utils/player-core";
import { SOUNDFONTS_MANIFEST_URL } from "./config.js";

export const useCatalog = (): SoundfontEntry[] => {
  const [catalog, setCatalog] = useState<SoundfontEntry[]>([]);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(SOUNDFONTS_MANIFEST_URL);
        if (!res.ok) return;
        const data = (await res.json()) as SoundfontEntry[];
        if (!cancelled) setCatalog(data);
      } catch {
        // Сетевые ошибки не критичны — UI покажет «каталог пуст».
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  return catalog;
};